import { render, staticRenderFns } from "./avtList.vue?vue&type=template&id=678b06ad&scoped=true"
import script from "./avtList.vue?vue&type=script&lang=js"
export * from "./avtList.vue?vue&type=script&lang=js"
import style0 from "./avtList.vue?vue&type=style&index=0&id=678b06ad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678b06ad",
  null
  
)

export default component.exports